import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Button } from '@/components/ui/button'
import BusyIndicator, { REGIONS } from '../../widgets/busyIndicator'
import Modal, { hideModal, showModal } from '../../widgets/modal'
import { actions } from '../ReleaseNotes/releaseNotes.slice'
import {
	deleteReleaseNote,
	fetchAllReleaseNotes,
} from '../ReleaseNotes/releaseNotes.asyncActions'
import { selectReleaseNoteToBeDeleted } from '../ReleaseNotes/releaseNotes.selectors'

const {
	setSelectedReleaseNoteModal,
	setShouldDisableAddButton,
	setIsReleaseNoteDeleted,
} = actions

const DeleteReleaseNoteModal = () => {
	const dispatch = useDispatch()
	const releaseNoteToBeDeleted = useSelector(selectReleaseNoteToBeDeleted)

	const resetModal = () => dispatch(setSelectedReleaseNoteModal())

	useEffect(() => {
		dispatch(showModal())
	}, [dispatch])

	const handleClose = () => {
		dispatch(hideModal())
		resetModal()
	}

	const footer = (
		<>
			<Button
				variant='danger'
				className='btn-big'
				data-dismiss='modal'
				onClick={() => {
					dispatch(deleteReleaseNote(releaseNoteToBeDeleted)).then(() => {
						dispatch(setIsReleaseNoteDeleted(true))
						dispatch(setShouldDisableAddButton(true))
						dispatch(fetchAllReleaseNotes()).then(() =>
							dispatch(setShouldDisableAddButton(false))
						)
						dispatch(hideModal())
						resetModal()
					})
				}}
			>
				<BusyIndicator region={REGIONS.DELETE_RELEASE_NOTE}>
					Delete
				</BusyIndicator>
			</Button>
			<Button variant='outline' className='btn-big' onClick={handleClose}>
				Cancel
			</Button>
		</>
	)
	return (
		<>
			<Modal
				title={`Are You Sure You Want to Delete?`}
				reset={resetModal}
				footer={footer}
				size='sm'
			></Modal>
		</>
	)
}
export default DeleteReleaseNoteModal
